/**
 * Generic Bootstrap 3 typeahead for use wherever it's needed.
 */

// Global var so async reqs can populate it for afterSelect() to utlise.
var $field = null;

$('.typeahead').typeahead({
	items: 'all',
	minLength: 3,
	autoSelect: false,
	fitToElement: true,
	source: function(query, process) {
		// Not sure why we need to dereference [1] here? Possibly, enabling
		// typeahead "transforms" the input field jQuery object into a super-object
		// unique to the typeahead package
		$field = $($('.typeahead')[1]);
		var url = $field.attr('data-target-url');
		
		$.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            success: function(json) {
                return process(json);
            }
        });
  },
  afterSelect: function (selected) {
    var $form = $field.closest('form');

    $form.submit();
  }
});
